const API_ROOT = (process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/client').replace(/\/$/, '');

async function parseResponse(response) {
  const text = await response.text();
  const payload = text ? JSON.parse(text) : {};

  if (!response.ok) {
    const error = new Error(payload.message || 'Request failed.');
    error.status = response.status;
    error.errors = payload.errors || {};
    throw error;
  }

  return payload;
}

export async function apiRequest(path, { method = 'GET', data, token } = {}) {
  const headers = {
    Accept: 'application/json',
  };

  if (data) {
    headers['Content-Type'] = 'application/json';
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_ROOT}${path}`, {
    method,
    headers,
    body: data ? JSON.stringify(data) : undefined,
  });

  return parseResponse(response);
}

export { API_ROOT };
